import axios from "axios";
import { GstAddressType } from "./types/GstAddressType";

export const createGstAddress = (
  gstAddressDetails: GstAddressType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.temp_gst_details`,
      {
        params: {
          context: {},
          data: gstAddressDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
